import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown, Users, Star, ChevronLeft, ChevronRight } from 'lucide-react';

const VITALIS_LOGO = "https://vitalis-sports.ch/wp-content/uploads/2024/10/Asset-3.png";

const TESTIMONIALS = [
  { name: "Remo", text: "Ich werde immer herzlich und persönlich empfangen. Die Infrastruktur ist zudem sehr innovativ.", image: null },
  { name: "Lisbeth", text: "Dank der Analyse mit dem Cardioscan, konnte ich frühzeitig einem Herz-Kreislaufproblem vorbeugen.", image: null },
  { name: "Fiorina", text: "Ich schätze am Vitalis Fitness besonders die persönliche Betreuung der Fitnesstrainer/innen, die jederzeit möglich ist.", image: null },
  { name: "Gert", text: "Das Team ist persönlich, unkompliziert und sehr sympathisch. Vitalis hat super Öffnungszeiten.", image: null },
  { name: "Vanja", text: "Ich werde immer freundlich und sogar mit Namen begrüsst. Die Oeffungszeiten sind toll; ich kann praktisch rund um die Uhr trainieren.", image: null },
  { name: "Giuseppe", text: "Ich bin seit Jahren sehr zufrieden mit dem Vitalis. Das freundliche und kompetente Personal und die Vielfalt an Angeboten wie z. B. Sauna und Tennisplätze machen für mich den Unterschied.", image: null },
];

function TestimonialSlider() {
  const [current, setCurrent] = useState(0);
  const next = () => setCurrent((c) => (c + 1) % TESTIMONIALS.length);
  const prev = () => setCurrent((c) => (c - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  useEffect(() => { const i = setInterval(next, 5000); return () => clearInterval(i); }, []);

  return (
    <div className="relative">
      <div className="overflow-hidden">
        <div className="flex transition-transform duration-500" style={{ transform: `translateX(-${current * 100}%)` }}>
          {TESTIMONIALS.map((t, i) => (
            <div key={i} className="w-full flex-shrink-0 px-4">
              <div className="max-w-2xl mx-auto text-center">
                <p className="text-xl md:text-2xl text-gray-700 italic mb-6">"{t.text}"</p>
                <div className="flex flex-col items-center">
                  <p className="font-bold text-gray-900 text-lg">{t.name}</p>
                  {t.image && <img src={t.image} alt={t.name} className="w-16 h-16 rounded-full object-cover mt-4" />}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 p-2 bg-white/80 hover:bg-white rounded-full shadow-lg"><ChevronLeft className="h-6 w-6" /></button>
      <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 p-2 bg-white/80 hover:bg-white rounded-full shadow-lg"><ChevronRight className="h-6 w-6" /></button>
      <div className="flex justify-center gap-2 mt-6">
        {TESTIMONIALS.map((_, i) => <button key={i} onClick={() => setCurrent(i)} className={`w-2 h-2 rounded-full ${i === current ? 'bg-orange-500' : 'bg-gray-300'}`} />)}
      </div>
    </div>
  );
}

export default function Fitness() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      {/* Extranet Banner */}
      <div className="bg-[#1e3a5f] text-white py-1.5 px-4 text-xs">
        <div className="max-w-7xl mx-auto flex items-center justify-end gap-3">
          <span className="text-white/70">Mitarbeiter-Bereich</span>
          <Link to="/login" className="flex items-center gap-1.5 bg-orange-500 hover:bg-orange-600 px-3 py-1 rounded text-xs font-medium transition-colors">
            <Users className="h-3 w-3" />
            Extranet
          </Link>
        </div>
      </div>

      {/* Header */}
      <header className="bg-white py-4 px-6 flex items-center justify-between relative z-50 shadow-sm">
        <Link to="/" className="flex items-center">
          <img src={VITALIS_LOGO} alt="Vitalis Sports" className="h-10" />
        </Link>
        <nav className="hidden lg:flex items-center gap-1">
          <Link to="/fitness" className="flex items-center gap-1 px-4 py-2 text-orange-500 font-medium">Fitness <ChevronDown className="h-4 w-4" /></Link>
          <Link to="/racket" className="flex items-center gap-1 px-4 py-2 text-gray-700 hover:text-orange-500 font-medium">Racket <ChevronDown className="h-4 w-4" /></Link>
          <Link to="/wellness" className="px-4 py-2 text-gray-700 hover:text-orange-500 font-medium">Wellness</Link>
          <Link to="/ueber-uns" className="flex items-center gap-1 px-4 py-2 text-gray-700 hover:text-orange-500 font-medium">Über uns <ChevronDown className="h-4 w-4" /></Link>
          <Link to="/kontakt" className="px-4 py-2 text-gray-700 hover:text-orange-500 font-medium">Kontakt</Link>
        </nav>
        <div className="flex items-center gap-4">
          <a href="https://www.courtsonline.ch/?a=Ng==" target="_blank" rel="noopener noreferrer" className="hidden sm:block bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded font-bold text-sm">PLATZ BUCHEN</a>
          <button onClick={() => setMenuOpen(!menuOpen)} className="lg:hidden p-2 hover:bg-gray-100 rounded">{menuOpen ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}</button>
        </div>
      </header>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="fixed inset-0 bg-white z-40 pt-20 lg:hidden overflow-y-auto">
          <nav className="flex flex-col py-4">
            <Link to="/fitness" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold text-orange-500 border-b border-gray-100">Fitness</Link>
            <Link to="/racket" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold text-gray-800 hover:text-orange-500 border-b border-gray-100">Racket</Link>
            <Link to="/wellness" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold text-gray-800 hover:text-orange-500 border-b border-gray-100">Wellness</Link>
            <Link to="/ueber-uns" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold text-gray-800 hover:text-orange-500 border-b border-gray-100">Über uns</Link>
            <Link to="/kontakt" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold text-gray-800 hover:text-orange-500 border-b border-gray-100">Kontakt</Link>
            <Link to="/" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold text-gray-800 hover:text-orange-500 border-b border-gray-100">← Zurück</Link>
          </nav>
        </div>
      )}

      {/* Hero Section with Video */}
      <section className="relative h-[70vh] overflow-hidden">
        <div className="absolute inset-0">
          <iframe
            src="https://player.vimeo.com/video/1026390685?background=1&autoplay=1&loop=1&muted=1"
            className="absolute w-[177.77vh] min-w-full min-h-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            frameBorder="0"
            allow="autoplay; fullscreen"
            title="Fitness Video"
          />
          <div className="absolute inset-0 bg-black/40" />
        </div>
        <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
          <h1 className="text-6xl md:text-8xl font-black text-orange-500 drop-shadow-lg">Cheibe Starch</h1>
          <a href="https://vitalis-sports.ch/beratungsgespraech/" target="_blank" rel="noopener noreferrer" className="mt-8 flex flex-col items-center text-white hover:text-orange-400 transition-colors">
            <span className="text-sm tracking-widest uppercase">Jetzt Beratungsgespräch buchen</span>
            <ChevronDown className="h-8 w-8 animate-bounce mt-2" />
          </a>
        </div>
      </section>

      {/* Kraft Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="aspect-video rounded-xl overflow-hidden shadow-lg">
              <img src="https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&q=80" alt="Krafttraining" className="w-full h-full object-cover" />
            </div>
            <div>
              <h2 className="text-4xl font-black text-gray-900 mb-6">Kraft</h2>
              <p className="text-gray-600 text-lg leading-relaxed mb-6">
                Krafttraining hilft dir beim Aufbau der Muskeln, steigert die Knochendichte und verbessert die Körperhaltung. 
                Auch das Immunsystem wird gestärkt. Im Vitalis Fitness kannst du am Zirkel, an herkömmlichen Geräten oder 
                im Workout-Bereich dein Krafttraining absolvieren. Wir helfen dir dabei, einen individuellen Plan zu erstellen.
              </p>
              <a href="https://vitalis-sports.ch/fitness/kraft/" target="_blank" rel="noopener noreferrer" className="inline-block border-2 border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-white px-6 py-3 rounded font-bold transition-colors">
                mehr erfahren
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Ausdauer Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="order-2 md:order-1">
              <h2 className="text-4xl font-black text-gray-900 mb-6">Ausdauer</h2>
              <p className="text-gray-600 text-lg leading-relaxed mb-6">
                Möchtest du Abnehmen? Oder deine Kondition verbessern? Egal welches Ziel du hast, wir stellen dir ein 
                individuelles Ausdauertraining zusammen, damit du dein Ziel erreichen kannst. Auf unseren topmodernen 
                Geräten mit grossem Bildschirm und Zugang zu allerlei Entertainment-Möglichkeiten, wird das Training spannend.
              </p>
              <a href="https://vitalis-sports.ch/fitness/ausdauer/" target="_blank" rel="noopener noreferrer" className="inline-block border-2 border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-white px-6 py-3 rounded font-bold transition-colors">
                mehr erfahren
              </a>
            </div>
            <div className="aspect-video rounded-xl overflow-hidden shadow-lg order-1 md:order-2">
              <img src="https://images.unsplash.com/photo-1576678927484-cc907957088c?w=800&q=80" alt="Ausdauertraining" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </section>

      {/* Gesundheitstraining Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="aspect-video rounded-xl overflow-hidden shadow-lg">
              <img src="https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=800&q=80" alt="Gesundheitstraining" className="w-full h-full object-cover" />
            </div>
            <div>
              <h2 className="text-4xl font-black text-gray-900 mb-6">Gesundheitstraining</h2>
              <p className="text-gray-600 text-lg leading-relaxed mb-6">
                Mit unserer hohen Fachkompetenz, sind wir die Spezialisten, wenn es ums Gesundheitstraining geht. 
                Bei gesundheitlichen Problemen, arbeiten wir auch gerne mit deinem Physiotherapeuten oder Arzt zusammen. 
                Unser Betreuungssystem sorgt dafür, dass du regelmässig neue Trainingspläne bekommst und während 
                deinen Trainings von unseren Trainern und Trainerinnen gut betreut bist.
              </p>
              <a href="https://vitalis-sports.ch/fitness/gesundheitstraining/" target="_blank" rel="noopener noreferrer" className="inline-block border-2 border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-white px-6 py-3 rounded font-bold transition-colors">
                mehr erfahren
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* SWICA Partner */}
      <section className="py-10 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 flex justify-center">
          <a href="https://www.swica.ch/de/kampagnen/fitness/fitness?utm_source=Active-Fitness-Banner&utm_medium=MESEV20S-active#stern01" target="_blank" rel="noopener noreferrer">
            <img src="https://vitalis-sports.ch/wp-content/uploads/2024/11/Swica.webp" alt="SWICA Partner" className="h-16" />
          </a>
        </div>
      </section>

      {/* Wie wir Fitness leben */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-8">
            Wie wir <span className="text-orange-500">Fitness</span> <span className="text-orange-500">Bewegung</span> <span className="text-orange-500">Sport</span> <span className="text-orange-500">Vitalis</span> leben
          </h2>
          <p className="text-gray-600 text-lg leading-relaxed">
            Wir legen grossen Wert auf eine persönliche Beratung und fachkompetente Betreuung. Als familiär geführter Betrieb 
            setzen wir auf modernste Technologie und individuelle Trainingspläne, die im Rahmen eines initialen Beratungsgesprächs 
            erstellt werden. Danach wird der Fortschritt durch sporadische Gespräche und Anpassungen des Plans begleitet – 
            perfekt abgestimmt auf deine Fitnessziele und Bedürfnisse.
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-orange-500">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4">Unsere Preise? Werde Vitalismember.</h2>
          <p className="text-white/90 text-xl mb-8">ab 83 Fr.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="https://vitalis-sports.ch/beratungsgespraech/" target="_blank" rel="noopener noreferrer" className="inline-block bg-white text-orange-500 hover:bg-gray-100 px-8 py-4 rounded font-bold text-lg transition-colors">
              Jetzt Beratung vereinbaren
            </a>
            <a href="https://vitalis-sports.ch/preise/" target="_blank" rel="noopener noreferrer" className="inline-block border-2 border-white text-white hover:bg-white hover:text-orange-500 px-8 py-4 rounded font-bold text-lg transition-colors">
              Termin finden
            </a>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-black text-gray-900">Das sagen unsere Member</h2>
          </div>
          <TestimonialSlider />
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-12">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <img src={VITALIS_LOGO} alt="Vitalis Sports" className="h-10 mb-4 brightness-0 invert opacity-70" />
              <p className="text-sm">Dein familiäres Fitness- und Sportcenter im Rheintal.</p>
            </div>
            <div>
              <h4 className="font-bold text-white mb-4">Angebot</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/fitness" className="hover:text-white">Fitness</Link></li>
                <li><Link to="/racket" className="hover:text-white">Racket</Link></li>
                <li><Link to="/wellness" className="hover:text-white">Wellness</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold text-white mb-4">Kontakt</h4>
              <ul className="space-y-2 text-sm">
                <li>Rorschacherstrasse 43</li>
                <li>9450 Lüchingen/Altstätten</li>
                <li>+41 71 755 50 66</li>
                <li>info@vitalis-sports.ch</li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold text-white mb-4">Extranet</h4>
              <p className="text-sm mb-4">Mitarbeiter-Bereich</p>
              <Link to="/login" className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded text-sm font-medium">
                <Users className="h-4 w-4" />
                Anmelden
              </Link>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm">© 2026 Vitalis Sports</p>
            <div className="flex gap-6 text-sm">
              <a href="https://vitalis-sports.ch/impressum/" target="_blank" rel="noopener noreferrer" className="hover:text-white">Impressum</a>
              <a href="https://vitalis-sports.ch/datenschutzerklaerung/" target="_blank" rel="noopener noreferrer" className="hover:text-white">Datenschutz</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
